























































































































































































































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import _ from 'lodash';
import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() oldData!: any;

  timeDisabled: any = [];

  addTime() {
    this.timeDisabled.push({
      weeks: [],
      time_start: '',
      time_end: '',
    });
  }

  delTime(idx: number) {
    this.$confirm({
      title: '确认信息',
      content: '确定要删除该时段吗？',
      onOk: async () => {
        this.timeDisabled.splice(idx, 1);
      },
    });
  }

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: '确认信息',
          content: '你确定要提交吗？',
          onOk: async () => {
            this.confirmLoading = true;
            const values: any = {};
            for (const key in fieldValues) {
              if (_.get(fieldValues, [key])) {
                const fieldValue = _.get(fieldValues, [key]);
                if (key === 'face_value') {
                  _.set(values, [key], this.tsMul(fieldValue, 100));
                } else if (key === 'sale_price') {
                  _.set(values, [key], this.tsMul(fieldValue, 100));
                } else {
                  _.set(values, [key], fieldValue);
                }
              }
            }

            _.set(values, ['disable_time'], JSON.stringify(this.timeDisabled));

            const res = await this.$store.dispatch('stadium/vipSettingEdit', {
              stadium_id: this.stadiumId,
              valid_sn: this.oldData.valid_sn,
              ...values,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }

  mounted() {
    // console.log(this.oldData);
    if (this.oldData.disable_time) {
      this.timeDisabled = this.oldData.disable_time;
    }
  }
}
